import classes from '../styles/Page.module.scss';

/**
 * Simfy Web Home Page
 *
 * @returns {JSX.Element}
 * @constructor
 */
const Legal = () => {
    return (
        <div className={classes.oPageHome}>
            <div className={classes.oContent}>
                <h1 className={`${classes.aPageTitle}`}>
                    SIMFY AFRICA PROPRIETARY LIMITED SIMFY WEBSITE TERMS AND CONDITIONS
                </h1>
                <p>
                    All references to &quot;<strong>the Company</strong>&quot;, &quot;
                    <strong>Simfy</strong>&quot;<strong>,</strong> &quot;<strong>we</strong>&quot;,
                    &quot;<strong>us</strong>&quot; and &quot; <strong>our</strong>&quot; in these
                    terms and conditions are deemed to refer to Simfy Africa Proprietary Limited, a
                    private company incorporated in accordance with the laws of South Africa, with
                    the registration number 2011/129834/07 , with our office&apos;s address at
                    Ground Floor, Darter Studio, Longkloof, 4 Darters Road, Gardens, Cape Town
                </p>
                <p>
                    (&quot;<strong>Simfy</strong>&quot;).
                </p>
                <p>
                    All references to &quot;<strong>you</strong>&quot;, &quot;<strong>user</strong>
                    &quot; and &quot;<strong>your</strong>&quot; are deemed to refer to any user
                    and/or visitor of<strong>,</strong> and other related URLs, and/or any ancillary
                    services (&quot; <strong>Website</strong>&quot;).
                </p>
                <ol className={classes.mContent}>
                    <li className={classes.mChapter}>
                        <h3 className={`${classes.aTitle} fnt30f`}>acceptance of the terms</h3>
                        <p>
                            Simfy permits the use of the Website subject to these Terms and
                            Conditions (&quot;<strong>Terms and Conditions</strong>&quot;) and our
                            <strong>Privacy Policy</strong>. By using, accessing and/or downloading
                            from the Website in any way, you shall be deemed to have accepted all
                            the Terms and Conditions unconditionally. You must not use the Website
                            if you do not agree to the Terms and Conditions.
                        </p>
                    </li>
                    <li className={classes.mChapter}>
                        <h3 className={`${classes.aTitle} fnt30f`}>Important Notice</h3>
                        <ol>
                            <li>
                                These Terms and Conditions apply to users who are consumers for
                                purposes of the Consumer Protection Act, 68 of 2008 (the &ldquo;
                                <strong>CPA</strong>&rdquo;). These Terms and Conditions may contain
                                provisions which:
                                <ol>
                                    <li>
                                        may limit the risk or liability of or a third party; and/or
                                    </li>
                                    <li>may create risk or liability for the user; and/or</li>
                                    <li>
                                        may compel the user to indemnify the us or a third party;
                                        and/or
                                    </li>
                                    <li>serves as an acknowledgement, by the user, of a fact;</li>
                                </ol>
                            </li>
                            <li>
                                <strong>
                                    &nbsp;Your attention is drawn to these terms (in bold font)
                                    because they are important and should be carefully noted.&nbsp;
                                </strong>
                            </li>
                            <li>
                                If there is any provision in these Terms and Conditions that you do
                                not understand, it is your responsibility to ask us to explain it to
                                you before you accept the Terms of Use or continue using the
                                Website. Nothing in these Terms of Conditions is intended or must be
                                understood to unlawfully restrict, limit or avoid any right or
                                obligation, as the case may be, created for either you or the us in
                                terms of the CPA.
                            </li>
                        </ol>
                    </li>
                    <li className={classes.mChapter}>
                        <h3 className={`${classes.aTitle} fnt30f`}>use of the Website</h3>
                        <ol>
                            <li>
                                We are a digital services company, that distributes digital content,
                                music and games from content partners and services developers, in
                                addition to enabling messaging functionality, making such content,
                                music, games and messaging functionality available to users of the
                                Ayoba application, a super-app owned and operated by our affiliate
                                Progressive tech Holdings.
                            </li>
                            <li>
                                The Website is available via a computer and/or using a mobile
                                device. The Website has specifically been developed for the use of
                                certain mobile devices and/or using a computer. It is therefore
                                assumed that you (a) understand the functionality and restrictions
                                of your smartphone/device and/or computer and (b) understand and are
                                bound by any other Terms and Conditions that exist when using the
                                smartphone/device and/or computer, and any networks that may provide
                                services to the smartphone/device.
                            </li>
                            <li>
                                You agree that you will not use any device, software or other
                                instrument to interfere or attempt to interfere with the proper
                                working of the Website. In addition, you agree that you will not use
                                any robot, spider, other automatic device, or manual process to
                                monitor, copy, distribute or modify the Website or the information
                                contained herein, without the prior written consent from an
                                authorised Company representative (such consent is deemed given for
                                standard search engine technology employed by internet search
                                websites to direct internet users to the Website).
                            </li>
                            <li>You may not use the Website for any illegal activity.</li>
                            <li>
                                You may not display, publish, copy, print, post or otherwise use the
                                Website and/or the information contained therein for the benefit of
                                any other website without the express prior written consent of an
                                authorised Company representative. You may not, in any way reverse
                                engineer the Website, or any component thereof, nor may you attempt
                                to do so. This includes, but is not limited to, disassembling,
                                decompiling, decrypting or any other actions that could possibly
                                reveal the source code of the Website or any portion thereof.
                            </li>
                            <li>
                                You may not use the results of the use of the Website for any other
                                purpose than to assist you in your personal capacity.
                            </li>
                            <li>
                                You may not use the location data provided for any other purpose
                                than defined by the Website.
                            </li>
                            <li>
                                The Company reserves the right to limit, disconnect or terminate
                                your use of the Website in the event of any abuse or misuse by you.
                            </li>
                            <li>
                                <strong>
                                    &nbsp;To the extent permissible by law, you further specifically
                                    indemnify and hold the Company, its employees, directors and
                                    associates harmless against any direct losses such as injury,
                                    illness, loss of limb, loss of life, financial losses, loss of
                                    property and any other assets, emotional distress, reputation
                                    risk and the like, that may arise due the use of the
                                    Website.&nbsp;
                                </strong>
                            </li>
                        </ol>
                    </li>
                    <li className={classes.mChapter}>
                        <h3 className={`${classes.aTitle} fnt30f`}>ownership and copyright</h3>
                        <ol>
                            <li>
                                The contents of the Website including any information, software,
                                icons, text, graphics, lay-outs, images, sound clips, trade names,
                                logos, trademarks and service marks are protected by law, including
                                but not limited to intellectual property, copyright and trade mark
                                law, and are owned by or licensed to the Company.
                            </li>
                            <li>
                                No licence to or right in any of such contents is granted to or
                                conferred upon you. Any unauthorised use, distribution or
                                reproduction of the said contents is prohibited.
                            </li>
                            <li>
                                The Website may allow you to download material, logos and trade
                                marks of third parties. All third party intellectual property rights
                                in the material, logos and trade marks remain with the third party
                                concerned. By downloading any such material from the Website you do
                                not obtain any intellectual property rights therein. The Company
                                grants you a non-exclusive, perpetual license to display the
                                material on your smartphone/device only. You may not share any
                                downloaded material with others.
                            </li>
                        </ol>
                    </li>
                    <li className={classes.mChapter}>
                        <h3 className={`${classes.aTitle} fnt30f`}>disclaimers</h3>
                        <ol>
                            <li>
                                <strong>
                                    Any person who accesses the Website or relies on the Website or
                                    on the information contained in the Website does so at his or
                                    her own risk.
                                </strong>
                            </li>
                            <li>
                                <strong>
                                    While the Company takes reasonable measures to ensure that the
                                    contents of the Website are accurate and complete, the Company
                                    makes no representations or warranties, whether express or
                                    implied, as to the quality, timeliness, operation, integrity,
                                    availability or functionality of the Website or as to the
                                    accuracy, completeness or reliability of any information on the
                                    Website.
                                </strong>
                            </li>
                            <li>
                                <strong>
                                    All information provided on the Website is provided &quot;as
                                    is&quot; without warranty of any kind, either express or
                                    implied, including, but not limited to, the implied warranties
                                    of merchantability, fitness for a particular purpose,
                                    completeness, or non-infringement, as may be allowed in law.
                                </strong>
                            </li>
                            <li>
                                <strong>
                                    The Company does not accept any responsibility for any errors or
                                    omissions on the Website.
                                </strong>
                            </li>
                            <li>
                                <strong>
                                    In addition to the disclaimers contained elsewhere in these
                                    Terms and Conditions, the Company also makes no warranty or
                                    representation, whether express or implied, that the information
                                    or files available on the Website are free of viruses, spyware,
                                    malware, trojans, destructive materials or any other data or
                                    code which is able to corrupt, destroy, compromise or jeopardise
                                    the operation, stability, security functionality or content of
                                    your computer system, computer network, hardware or software in
                                    any way.
                                </strong>
                            </li>
                            <li>
                                <strong>
                                    We do not warrant that the Website will be compatible with your
                                    smartphone/device.
                                </strong>
                            </li>
                        </ol>
                    </li>
                    <li className={classes.mChapter}>
                        <h3 className={`${classes.aTitle} fnt30f`}>third party websites</h3>
                        <ol>
                            <li>
                                The Website may contain links or references to other websites or
                                mobile applications (&quot;<strong>Third Party Websites</strong>
                                &quot;) outside of our control, including those of advertisers.
                                These Terms and Conditions do not apply to those Third Party
                                Websites and the Company is not responsible for the practices and/or
                                privacy policies of those Third Party Websites or the cookies that
                                those sites may use.
                            </li>
                            <li>
                                Notwithstanding the fact that the Website may refer to or provide
                                links to Third Party Websites,
                                <strong>
                                    your use of such Third Party Websites is entirely at your own
                                    risk and we are not responsible for any loss, expense, claim or
                                    damage, whether direct, indirect or consequential, arising from
                                    your use of such Third Party Websites or your reliance on any
                                    information contained thereon
                                </strong>
                                .
                            </li>
                        </ol>
                    </li>
                    <li className={classes.mChapter}>
                        <h3 className={`${classes.aTitle} fnt30f`}>privacy policy</h3>
                        <ol>
                            <li>
                                We recognize the importance of protecting your privacy in respect of
                                personal information collected by us when you use the Website.
                            </li>
                            <li>
                                <strong>
                                    By continuing to use the Website you agree to the Terms and
                                    Conditions set out in our Privacy Policy and you consent to us
                                    collecting and using your personal information for the purposes
                                    set out in our Privacy Policy. If you do not agree to this
                                    Privacy Policy, please do not continue to use the Website.
                                </strong>
                            </li>
                        </ol>
                    </li>
                    <li className={classes.mChapter}>
                        <h3 className={`${classes.aTitle} fnt30f`}>limitation of liability</h3>
                        <ol>
                            <li>
                                <strong>
                                    The Company shall not be liable for any direct, indirect,
                                    incidental, special or consequential injury, loss or damages
                                    which might arise from your use of, or reliance upon, any
                                    material or content contained in, or inability to use, and/or
                                    unlawful activity on, the Website and/or any linked third party
                                    website, unless such loss or damages arise due to the gross
                                    negligence of the Company.
                                </strong>
                            </li>
                            <li>
                                <strong>
                                    You hereby indemnify the Company against any loss, claim or
                                    damage which may be suffered by yourself or any third party
                                    arising in any way from your use of the Website and/or any
                                    linked third party website.
                                </strong>
                            </li>
                        </ol>
                    </li>
                    <li className={classes.mChapter}>
                        <h3 className={`${classes.aTitle} fnt30f`}>changes</h3>
                        <p>
                            The Company reserves the right to update and/or amend the Terms and
                            Conditions from time to time and without any notice, and you are
                            accordingly encouraged to check the Website regularly. Any such change
                            will only apply to your use of the Website after the change is displayed
                            on the Website. If you use the Website after such updated or amended
                            Terms and Conditions have been displayed on the Website, you will be
                            deemed to have accepted such updates or amendments.
                        </p>
                    </li>
                    <li className={classes.mChapter}>
                        <h3 className={`${classes.aTitle} fnt30f`}>availability and termination</h3>
                        <ol>
                            <li>
                                We will use reasonable endeavours to maintain the availability of
                                the Website, except during scheduled maintenance periods, and
                                reserve the right to discontinue providing the Website or any part
                                thereof with or without notice to you.
                            </li>
                            <li>
                                The Company may in its sole discretion terminate, suspend and modify
                                the Website, with or without notice to you.
                                <strong>
                                    You agree that the Company will not be liable to you in the
                                    event that it chooses to suspend, modify or terminate the
                                    Website.
                                </strong>
                            </li>
                        </ol>
                    </li>
                    <li className={classes.mChapter}>
                        <h3 className={`${classes.aTitle} fnt30f`}>governing law</h3>
                        <p>
                            These Terms and Conditions shall be governed and interpreted in
                            accordance with the laws of the Republic of South Africa. Your continued
                            use of the Website will constitute your consent and submission to the
                            jurisdiction of the South African courts regarding all proceedings,
                            transactions, applications or the like instituted by either party
                            against the other, arising from any of these Terms and Conditions.
                        </p>
                    </li>
                    <li className={classes.mChapter}>
                        <h3 className={`${classes.aTitle} fnt30f`}>general</h3>
                        <ol>
                            <li>
                                You may not cede, assign or otherwise transfer your rights and
                                obligations in terms of these Terms and Conditions to any third
                                party.
                            </li>
                            <li>
                                Any failure on the part of you or the Company to enforce any right
                                in terms hereof shall not constitute a waiver of that right.
                            </li>
                            <li>
                                If any term or condition contained herein is declared invalid, the
                                remaining Terms and Conditions will remain in full force and effect.
                            </li>
                            <li>
                                No indulgence, extension of time, relaxation or latitude which any
                                party (&quot;<strong>the grantor</strong>&quot;) may show grant or
                                allow to the other (&quot;<strong>the grantee</strong>&quot;) shall
                                constitute a waiver by the grantor of any of the grantor&apos;s
                                rights and the grantor shall not thereby be prejudiced or stopped
                                from exercising any of its rights against the grantee which may have
                                arisen in the past or which might arise in the future.
                            </li>
                            <li>
                                These Terms and Conditions contain the whole agreement between you
                                and the Company relating to the subject matter hereof and no other
                                warranty or undertaking is valid, unless contained in these Terms
                                and Conditions.
                            </li>
                            <li>
                                For all legal correspondence, our address is Ground Floor, Darter
                                Studio, Longkloof, 4 Darters Road, Gardens, Cape Town under these
                                Terms and Conditions.
                            </li>
                            <li>
                                Should you wish to contact us please email us at &nbsp;
                                <a href="mailto:legal@simfy.africa">legal@simfy.africa</a>
                            </li>
                        </ol>
                    </li>
                </ol>
            </div>
        </div>
    );
};

export default Legal;
